export const HTTP_BAD_REQUEST = 400;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_UNPROCESSABLE_ENTITY = 422;
export const HTTP_INTERNAL_SERVER = 500;

export class HttpError extends Error {
    /**
     * Constructor
     * @param statusCode {int}
     * @param message {string}
     * @param [response] {*}
     * @param [previous] {Error}
     */
    constructor(statusCode, message, response, previous) {
        super(message);
        this.name = 'HttpError';
        this.statusCode = statusCode || 500;
        this.response = response;
        this.previous = previous;
    }
}